/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RealingoInputs */

const cs_enum_realingo = /** @type {(inputs: Enum_RealingoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realingo`)
};

const en_enum_realingo = /** @type {(inputs: Enum_RealingoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realingo`)
};

/**
* | output |
* | --- |
* | "Realingo" |
*
* @param {Enum_RealingoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_realingo = /** @type {((inputs?: Enum_RealingoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RealingoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_realingo(inputs)
	return cs_enum_realingo(inputs)
});